import { useCallback } from 'react';
import { ChatType } from '../../api/chats';
import { MessageType, ChatMember } from '../../types/message';

interface UsePersonaProps {
  chatObj: ChatType | null;
  setChatObj: (chat: ChatType) => void;
  updateMessages: (messages: MessageType[]) => void;
  currentMember: ChatMember | null;
}

export const usePersona = ({
  chatObj,
  setChatObj,
  updateMessages,
  currentMember
}: UsePersonaProps) => {
  
  // Helper function to get the current persona username for messages
  const getMessagePersona = useCallback((): string | undefined => 
    currentMember?.member_type === 'persona' ? currentMember.username : undefined,
  [currentMember]);
  
  // Handle selecting a persona
  const handlePersonaSelect = useCallback(async (persona: { id: string }) => {
    if (!chatObj) return;
    
    try {
      // Update the chat with the new persona
      const updatedChat = await chatObj.setPersona(persona.id);
      setChatObj(updatedChat);
      updateMessages(updatedChat.messages || []);
    } catch (err) {
      console.error('Failed to set persona:', err);
    }
  }, [chatObj, setChatObj, updateMessages]);

  return { 
    getMessagePersona,
    handlePersonaSelect
  };
};

export default usePersona; 